import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import TaxRates2026 from "../components/TaxRates2026"


const TaxRates2026Page = () => (
  <Layout>
    <Seo title="Leano and Cruz, CPAs - 2026 Federal Income Tax Brackets (for taxes due in April 2027)" />
    <TaxRates2026 />
 </Layout>
)

export default TaxRates2026Page

